<div class="container">
    <div class="columns">
        <div class="text">
            <h1>Collect meaningful feedback</h1>
            <p>
                Urlo puts customer input where it belongs—in your hands, organized and ready to act on. Build the feedback button your brand deserves, then watch real insights flow in.
            </p>
            <a routerLink="/builder" class="btn btn-primary mr">Create your feedback button</a>
            <a href="#how-it-works" class="btn btn-secondary">How it works</a>
        </div>
        <div class="image">
            <img src="assets/img/hero.webp" />
        </div>
    </div>
</div>
